import { ContentType } from '../../services';

const routeMap = {};
routeMap[ContentType.gpsdd] = '/review';

// Converts content type to the approriate route
export function getRoutePathname(contentType: ContentType): string {
  if (routeMap[contentType]) {
    return routeMap[contentType] as string;
  } else {
    // Default returns to dashboard
    return '/';
  }
}
